module.exports = __webpack_public_path__ + "img/territorios-dashboard.9aeec791.svg";